module.exports = require("express-jwt");


//////////////////
// WEBPACK FOOTER
// external "express-jwt"
// module id = 13
// module chunks = 0